import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { async } from 'q';


export async function query(payload) {
  return request(`/iwms-wms/wms/sowingpick/page`, {
    method: 'POST',
    body: payload,
  });
}
export async function get(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.uuid}`);
}

export async function getByNumber(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.billNumber}/get?dcUuid=${loginOrg().uuid}`);

}

export async function audit(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.uuid}/audit?version=${payload.version}`, {
    method: 'POST',
    body: payload,
  })
}
export async function batchAudit(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.uuid}/auditInitial?pickQty=${payload.pickQty}&version=${payload.version}&summary=${payload.summary}&containerBarcode=${payload.targetContainerBarcode}`, {
    method: 'POST',
    body: payload,
  })
}

export async function modifysowingMethod(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.uuid}/modifysowingMethod?version=${payload.version}`, {
    method: 'POST',
  })
}

export async function modifySummaryPickMethod(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.uuid}/modifySummaryPickMethod?version=${payload.version}`, {
    method: 'POST',
  })
}

export async function modifyPicker(payload) {
  return request(`/iwms-wms/wms/sowingpick/${payload.billNumber}/modifyPicker?dcUuid=${loginOrg().uuid}&pickerCode=${payload.pickerCode}`, {
    method: 'POST',
  })
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/sowingpick/modify`, {
    method: 'POST',
    body: payload,

  })
}

export async function queryByWaveBill(payload) {
  return request(`/iwms-wms/wms/sowingpick/queryByWaveBill?waveBillUuid=${payload.waveBillUuid}`);
}

export async function pickup(payload) {
  return request(`/iwms-wms/wms/sowingpick/pickup?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST',
  });
}

export async function allocate(payload) {
  return request(`/iwms-wms/wms/sowingpick/allocate?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST',
  });
}
